import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const AirportRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--airport']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
